import "@/App.css";
import CardCounter from "@/components/CardCounter";

function App() {
  return <CardCounter />;
}

export default App;
